import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '../../axios-instance';
import { BaseError } from '@utils/types/shared/base';

export interface OnPremBundlePayload {
  licensee: string;
  org_limit: number;
  user_limit: number;
  max_processing?: number;
  expires?: string | null;
  realtime?: boolean;
  max_realtime_streams?: number | null;
  realtime_languages?: string[] | null;
}

// Returns the filename extracted from Content-Disposition (or the fallback).
export const downloadOnPremBundle = async (
  payload: OnPremBundlePayload
): Promise<string> => {
  const response = await Axios.post(
    'api/admin/licensing/on-prem-bundle',
    { ...payload, is_online: false },
    { responseType: 'blob' }
  );

  const contentDisposition = response.headers['content-disposition'] as
    | string
    | undefined;
  let filename = 'onprem-bundle.zip';
  if (contentDisposition) {
    const match = /filename[^;=\n]*=(['"]?)([^'";\n]+)\1/.exec(
      contentDisposition
    );
    if (match?.[2]) filename = match[2].trim();
  }

  const url = URL.createObjectURL(response.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  return filename;
};

export const useDownloadOnPremBundle = () =>
  useMutation<string, AxiosError<BaseError>, OnPremBundlePayload>(
    downloadOnPremBundle
  );
